"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DoubleButton = exports.DangerButton = exports.LinkAsButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _reactIntl = require("react-intl");

var _filteredLink = _interopRequireDefault(require("../filteredLink"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Elements = require("./Elements");

var _excluded = ["asElement", "className", "message", "role", "type", "primary", "secondary", "tertiary", "hollow", "black", "white", "small", "icon", "id", "children", "href", "danger", "onClick", "onBlur", "onKeyDown", "disabled", "to", "fullWidth", "autoWidth", "transparent", "messageValues"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LinkAsButton = (0, _filteredLink["default"])(['primary', 'secondary', 'tertiary', 'hollow', 'black', 'white', 'hasIcon', 'small', 'danger', 'fullWidth', 'autoWidth', 'transparent', 'showFocusState']);
exports.LinkAsButton = LinkAsButton;

var StyledButton = function StyledButton(_ref) {
  var asElement = _ref.asElement,
      className = _ref.className,
      message = _ref.message,
      role = _ref.role,
      type = _ref.type,
      primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      hollow = _ref.hollow,
      black = _ref.black,
      white = _ref.white,
      small = _ref.small,
      icon = _ref.icon,
      id = _ref.id,
      children = _ref.children,
      href = _ref.href,
      danger = _ref.danger,
      onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      onKeyDown = _ref.onKeyDown,
      disabled = _ref.disabled,
      to = _ref.to,
      fullWidth = _ref.fullWidth,
      autoWidth = _ref.autoWidth,
      transparent = _ref.transparent,
      messageValues = _ref.messageValues,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  if (process.env.NODE_ENV === 'development' && (primary && secondary || primary && tertiary || secondary && tertiary)) {
    // eslint-disable-next-line no-console
    console.error('Button should only be one of `primary`, `secondary`, or `tertiary`');
  }

  var btnRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isClicked = _useState2[0],
      setIsClicked = _useState2[1];

  var iconPart = null;

  if (icon && typeof icon === 'string' && !icon.includes('/')) {
    iconPart = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "button-icon",
      size: "xs",
      svg: icon
    });
  } else if (icon && icon.includes('/')) {
    iconPart = /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
      cacheRequests: true,
      uniquifyIDs: true,
      className: "button-icon",
      src: icon
    });
  } // eslint-disable-next-line no-nested-ternary


  var buttonContent = message && typeof message === 'string' ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: message,
    values: messageValues
  }) : typeof children === 'string' ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: children
  }) : children || message;

  var defaultKeyDown = function defaultKeyDown(e) {
    if (e.key === 'Enter') {
      if (type === 'submit') e.stopPropagation();
      if (onClick) onClick(e);
    }
  };

  var handleClick = function handleClick(e) {
    // detail === 0 means the <a> tag was activated with the Enter key
    // onKeydown is also triggered
    if ((asElement === 'a' || href) && (e === null || e === void 0 ? void 0 : e.detail) === 0) return; // detail === 1 means the <a> tag was activated with a click

    setIsClicked(true);

    if ((rest === null || rest === void 0 ? void 0 : rest.target) === '_blank') {
      var _btnRef$current, _btnRef$current$blur;

      btnRef === null || btnRef === void 0 ? void 0 : (_btnRef$current = btnRef.current) === null || _btnRef$current === void 0 ? void 0 : (_btnRef$current$blur = _btnRef$current.blur) === null || _btnRef$current$blur === void 0 ? void 0 : _btnRef$current$blur.call(_btnRef$current);
    }

    if (onClick) onClick(e);
  };

  var handleBlur = function handleBlur(e) {
    setIsClicked(false);
    if (onBlur) onBlur(e);
  };

  return /*#__PURE__*/_react["default"].createElement(_Elements.Button // Safe guards against the old implementation of just passing href to button from not functioning
  , (0, _extends2["default"])({
    as: asElement || (href ? 'a' : undefined),
    tabIndex: 0,
    id: id || undefined,
    className: className,
    role: href || to ? 'link' : role,
    type: href || to ? undefined : type,
    href: href,
    to: to,
    primary: primary || !secondary && !tertiary,
    secondary: secondary,
    tertiary: tertiary,
    danger: danger || type === 'danger',
    small: small,
    hollow: hollow,
    black: black,
    white: white,
    ref: btnRef,
    onClick: disabled ? function () {} : handleClick,
    onKeyDown: disabled ? function () {} : defaultKeyDown || onKeyDown,
    hasIcon: !!icon,
    disabled: disabled,
    fullWidth: fullWidth,
    autoWidth: autoWidth,
    transparent: secondary && transparent,
    onBlur: handleBlur,
    showFocusState: !isClicked
  }, rest), iconPart, buttonContent);
};

StyledButton.propTypes = {
  asElement: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape()]),
  role: _propTypes["default"].oneOf(['button', 'link']),
  type: _propTypes["default"].oneOf(['button', 'submit', 'reset', 'danger']),
  primary: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  tertiary: _propTypes["default"].bool,
  hollow: _propTypes["default"].bool,
  black: _propTypes["default"].bool,
  white: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  id: _propTypes["default"].string,
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node]),
  href: _propTypes["default"].string,
  className: _propTypes["default"].string,
  danger: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].number,
  onClick: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  to: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape()]),
  fullWidth: _propTypes["default"].bool,
  autoWidth: _propTypes["default"].bool,
  transparent: _propTypes["default"].bool,
  messageValues: _propTypes["default"].shape()
};
StyledButton.defaultProps = {
  asElement: undefined,
  role: 'button',
  type: 'button',
  primary: false,
  secondary: false,
  tertiary: false,
  hollow: false,
  black: false,
  white: false,
  small: false,
  icon: null,
  id: '',
  children: null,
  message: '',
  href: null,
  danger: false,
  tabIndex: 0,
  onClick: undefined,
  onBlur: undefined,
  onKeyDown: undefined,
  disabled: false,
  className: undefined,
  to: undefined,
  fullWidth: false,
  autoWidth: false,
  transparent: false,
  messageValues: undefined
};

var DangerButton = function DangerButton(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledButton, (0, _extends2["default"])({
    danger: true
  }, props));
};

exports.DangerButton = DangerButton;

var DoubleButton = function DoubleButton(_ref2) {
  var id = _ref2.id,
      cancelMessage = _ref2.cancelMessage,
      primaryMessage = _ref2.primaryMessage,
      cancelOnClick = _ref2.cancelOnClick,
      primaryOnClick = _ref2.primaryOnClick,
      primaryType = _ref2.primaryType,
      stacked = _ref2.stacked,
      smallPrimary = _ref2.smallPrimary,
      disabledPrimary = _ref2.disabledPrimary,
      cancelButtonDanger = _ref2.cancelButtonDanger;
  return /*#__PURE__*/_react["default"].createElement(_Elements.DoubleButtonContainer, {
    stacked: stacked,
    id: id || undefined
  }, /*#__PURE__*/_react["default"].createElement(StyledButton, {
    tertiary: true,
    danger: cancelButtonDanger,
    onClick: cancelOnClick,
    message: cancelMessage
  }), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    disabled: disabledPrimary,
    small: smallPrimary,
    type: primaryType,
    onClick: primaryOnClick,
    message: primaryMessage
  }));
};

exports.DoubleButton = DoubleButton;
DoubleButton.defaultProps = {
  id: '',
  cancelMessage: 'cta.cancel',
  primaryMessage: 'cta.submit',
  primaryType: 'button',
  primaryOnClick: null,
  stacked: false,
  smallPrimary: false,
  disabledPrimary: false,
  cancelButtonDanger: false
};
DoubleButton.propTypes = {
  id: _propTypes["default"].string,
  cancelMessage: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),
  primaryMessage: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),
  cancelOnClick: _propTypes["default"].func.isRequired,
  primaryOnClick: _propTypes["default"].func,
  primaryType: _propTypes["default"].string,
  stacked: _propTypes["default"].bool,
  smallPrimary: _propTypes["default"].bool,
  disabledPrimary: _propTypes["default"].bool,
  cancelButtonDanger: _propTypes["default"].bool
};
var _default = StyledButton;
exports["default"] = _default;